import Pqp from "../../../3x1010/Pqp";

export default class MouseControl {
  constructor(callback) {
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;
    this.callback = callback;
    this.enabled = false;

  }

  destroy() {
    if (Pqp.isMobile()) {
      jQuery(window).off("touchstart.key");
      jQuery(window).off("touchend.key");
    } else {
      jQuery(window).off("mousedown.key");
      jQuery(window).off("mouseup.key");
    }
  }

  init() {
    if (Pqp.isMobile()) {
      jQuery(window).on("touchstart.key", this.onKeyDown.bind(this));
      jQuery(window).on("touchend.key", this.onKeyUp.bind(this));
    } else {
      jQuery(window).on("mousedown.key", this.onKeyDown.bind(this));
      jQuery(window).on("mouseup.key", this.onKeyUp.bind(this));
    }
  }

  enable(lFlag) {
    this.enabled = lFlag;
  }

  onKeyDown(e) {
    //e.preventDefault();
    this.timer = new Date().getTime();
    this.idto = setTimeout(this.crouch.bind(this));
  }

  crouch() {
    //console.log("courch")
    this.s = 1;
    this.callback.call(null, this);
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;

  }

  onKeyUp(e) {
    //e.preventDefault();
    if (new Date().getTime() - this.timer < 150) {
      clearTimeout(this.idTo);
      this.n = 1;
      //console.log("jump")
    } else {
      this.s = 0;
    }

    this.callback.call(null, this);
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;


  }



}


